import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputBase, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, Typography } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import moment from 'moment';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { InputSearchButtonsStyle, InputSearchStyle } from '../styles/FormStyle';

import { ObtenerMateria } from '../connections/catalogos/MateriaConnection';
import { NuevaSentencia } from '../connections/sentencia/SentenciaConnection';
import { BuscarExpediente } from '../connections/recepcion/ExpedienteConnection';
import { ObtenerAutoridadesMaterias } from '../connections/catalogos/AutoridadConnection';

import { MateriaProps } from '../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../interfaces/catalogos/AutoridadInterface';
import { DialogBuscarCitacionSentencia } from './DialogBuscarCitacionSentencia';
import { NuevaSentenciaParams } from '../interfaces/sentencia/SentenciaInterface';
import { BuscarExpedienteResponse, defaultExpedienteResponse } from '../interfaces/recepcion/ExpedienteInterface';
import { CitacionSentenciaProps, defaultCitacionSentencia } from '../interfaces/sentencia/CitacionSentenciaInterface';

interface Props {
    openDialog:          boolean;
    handleCloseDialog:   () => void;
}

export const DialogNuevaSentencia = ( { openDialog, handleCloseDialog }: Props ) => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [loading, setLoading] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [openBuscarCitacion, setOpenBuscarCitacion] = useState( false );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [tipoSentencia, setTipoSentencia] = useState( 0 );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [numeroExpediente, setNumeroExpediente] = useState( '' );
    const [expediente, setExpediente] = useState<BuscarExpedienteResponse>( defaultExpedienteResponse );

    const [citacionSentencia, setCitacionSentencia] = useState<CitacionSentenciaProps>( defaultCitacionSentencia );

    const obtenerCitacion = ( data : any ) => setCitacionSentencia( data );

    const handleNuevaSentencia = async () => {

        setLoadingGuardar( true );

        const params: NuevaSentenciaParams = {
            idTipoSentencia: tipoSentencia,
            idExpediente: expediente?.idExpediente ?? 0,
            idCitacionSentencia: citacionSentencia?.idCitacionSentencia ?? 0,
        }

        await NuevaSentencia( params ).then(resp => {

            setTimeout(() => {

                const { message, success, idSentencia } = resp;

                if ( success ) {

                    setLoadingGuardar( false );
                    navigate(`/sentencia/elaborar/${ idSentencia }`);

                }
                else {

                    setLoadingGuardar( false );
                    dispatch(openSnackbar({ message, variant: 'error' }));

                }

            }, 700);

        });

    }

    const handleBuscarExpediente = async () => {

        setLoading( true );

        await BuscarExpediente({ numeroExpediente, idAutoridad: autoridad }).then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    handleClear();

                    setExpediente( resp );
                    setLoading( false );

                }
                else {

                    handleClear();
                    setLoading( false );

                    dispatch(openSnackbar({ message, variant: 'error' }));

                }

            }, 700);

        });

    }

    const handleClear = () => {

        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );
        setCitacionSentencia( defaultCitacionSentencia );

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

    }

    const handleCerrarDialog = () => {

        handleClear();
        handleCloseDialog();

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then(resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then(resp => {
                setAutoridadArray( resp );
            });

        }

        if ( materia !== 0 ) {
            Obtener();
        }

    }, [ materia ]);

    return (
        <>

            <Dialog open={ openDialog } maxWidth='md' fullWidth={ true }>

                <DialogTitle>Nueva sentencia</DialogTitle>

                <DialogContent>

                    <Grid container spacing={ 3 } mt={ 1 }>

                        <Grid size={{ xs: 12, md: 4 }}>

                            <FormControl required fullWidth>

                                <InputLabel>Materia</InputLabel>

                                <Select
                                    label="Materia"
                                    value={ materia }
                                    onChange={ ( e ) => setMateria( parseInt( e.target.value.toString() ) ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        materiaArray
                                        .filter( ( e ) => e.idMateria === 5 || e.idMateria === 6 )
                                        .map( ( e ) => (
                                            <MenuItem key={ e.idMateria } value={ e.idMateria }>{e.descripcion}</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 8 }}>

                            <FormControl required fullWidth>

                                <InputLabel>Autoridad</InputLabel>

                                <Select
                                    label="Autoridad"
                                    value={ autoridad }
                                    onChange={ ( e ) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                    disabled={ materia === 0 }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        autoridadArray.map( ( e ) => (
                                            <MenuItem key={ e.idAutoridad } value={ e.idAutoridad }>{e.descripcion}</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <Paper
                                component="div"
                                sx={ InputSearchStyle }
                            >

                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Buscar por número de expediente"
                                    value={ numeroExpediente }
                                    onChange={ ( e ) => { setNumeroExpediente( e.target.value ) } }
                                />

                                <Button
                                    type="button"
                                    variant='contained'
                                    size='small'
                                    sx={ InputSearchButtonsStyle }
                                    loading={ loading }
                                    disabled={ autoridad === 0 }
                                    onClick={ handleBuscarExpediente }
                                >
                                    <SearchIcon />
                                </Button>

                            </Paper>

                        </Grid>

                        {
                            expediente.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography> }
                                                    secondary={
                                                        expediente.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> {expediente.numeroExpediente} (F. {expediente.numeroFolio}) </Typography>
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> {expediente.numeroExpediente} </Typography>
                                                    }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> {expediente.tipoJuicio} </Typography> }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        expediente.actores.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> {actor} </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    {
                                        expediente.demandados.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> {demandado} </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                </>
                        }

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Seleccione un tipo de sentencia:</FormLabel>
                                <RadioGroup row>

                                    <FormControlLabel
                                        label="Sentencia definitiva"
                                        control={
                                            <Radio
                                                checked={ tipoSentencia === 1 }
                                                onChange={ () => setTipoSentencia( 1 ) }
                                            />
                                        }
                                    />

                                    <FormControlLabel
                                        label="Sentencia interlocutoria"
                                        control={
                                            <Radio
                                                checked={ tipoSentencia === 2 }
                                                onChange={ () => setTipoSentencia( 2 ) }
                                            />
                                        }
                                    />

                                </RadioGroup>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <Paper
                                component="div"
                                sx={ InputSearchStyle }
                            >

                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Buscar citación de sentencia"
                                    value={ citacionSentencia?.fecha ? moment( citacionSentencia?.fecha ).format('DD-MM-YY HH:mm a') : '' }
                                    onChange={ () => {} }
                                />

                                <Button
                                    type="button"
                                    variant='contained'
                                    size='small'
                                    sx={ InputSearchButtonsStyle }
                                    disabled={ !expediente.success || tipoSentencia === 0 }
                                    onClick={ () => setOpenBuscarCitacion( true ) }
                                >
                                    <SearchIcon />
                                </Button>

                            </Paper>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>
                    <Button
                        variant="contained"
                        loading={ loadingGuardar }
                        onClick={ handleNuevaSentencia }
                        disabled={
                            ( !expediente.success || citacionSentencia?.idCitacionSentencia === 0 )
                        }
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>

            <DialogBuscarCitacionSentencia
                open={ openBuscarCitacion }
                handleClose={ () => setOpenBuscarCitacion( false ) }
                expediente={ expediente }
                tipoSentencia={ tipoSentencia }
                obtenerCitacion={ obtenerCitacion }
            />
        </>
    )
}
